import React from 'react';

import './notificationDashboard.css';

import { connect } from 'react-redux';
import { Button, TextField, Checkbox, Snackbar } from '@material-ui/core';
import api from '../../lib/api';

class NotificationDashboard extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      emailId: '',
      title: '',
      subtitle: '',
      key: '',
      type: '',
      showImageInContent: false,
      description: '',
      actionButtonText: '',
      actionButtonLink: '',
      imageUrl: '',
      videoUrl: ''
    };
  }

  componentDidMount() {}

  componentWillMount() {}

  fetchDataFromApi = async key => {
    const data = await api.getNotificationKeyData(key);

    if (Object.keys(data).length > 0) {
      this.setState({
        title: data.title || '',
        subtitle: data.subtitle || '',
        type: data.type || '',
        showImageInContent: !!data.showImageInContent,
        description: data.description || '',
        actionButtonText: data.actionButtonText || '',
        actionButtonLink: data.actionButtonLink || '',
        imageUrl: data.imageUrl || '',
        videoUrl: data.videoUrl || ''
      });
    } else {
      this.setState({
        title: '',
        subtitle: '',
        type: '',
        showImageInContent: false,
        description: '',
        actionButtonText: '',
        actionButtonLink: '',
        imageUrl: '',
        videoUrl: ''
      });
    }
  };

  sendNotification = async () => {
    const {
      emailId,
      title,
      subtitle,
      key,
      type,
      showImageInContent,
      description,
      actionButtonText,
      actionButtonLink,
      imageUrl,
      videoUrl
    } = this.state;

    if (!emailId || !emailId.trim()) {
      this.setState({
        snackbarMessage: 'Please enter email id'
      });
    } else if (!key || !key.trim()) {
      this.setState({
        snackbarMessage: 'Key cannot ne empty'
      });
    } else if (!title || !title.trim()) {
      this.setState({
        snackbarMessage: 'Title cannot ne empty'
      });
    } else if (!subtitle || !subtitle.trim()) {
      this.setState({
        snackbarMessage: 'Subtitle cannot ne empty'
      });
    } else if (!type || !type.trim()) {
      this.setState({
        snackbarMessage: 'Notification Type cannot ne empty'
      });
    } else {
      try {
        await api.sendNotification({
          emailId,
          title,
          subtitle,
          key,
          type,
          showImageInContent,
          description,
          actionButtonText,
          actionButtonLink,
          imageUrl,
          videoUrl
        });
        this.setState({
          snackbarMessage: 'Notification sent'
        });
      } catch (e) {
        this.setState({
          snackbarMessage: e.message
        });
      }
    }
  };

  renderScreen = () => {
    const {
      emailId,
      title,
      subtitle,
      key,
      type,
      showImageInContent,
      description,
      actionButtonText,
      actionButtonLink,
      imageUrl,
      videoUrl
    } = this.state;
    return (
      <div className={'notification-container'}>
        <table>
          <tbody>
            <tr>
              <td>Send notification</td>
              <td className={'input-container-td'}>
                <TextField
                  placeholder={'Email id'}
                  value={emailId}
                  onChange={event =>
                    this.setState({ emailId: event.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>Key</td>
              <td className={'input-container-td'}>
                <TextField
                  placeholder={'Enter firebase key'}
                  value={key}
                  onBlur={event => {
                    this.fetchDataFromApi(event.target.value).catch(reason => {
                      console.log(reason);
                    });
                  }}
                  onChange={event => this.setState({ key: event.target.value })}
                />
              </td>
            </tr>
            <tr>
              <td>Title</td>
              <td className={'input-container-td'}>
                <TextField
                  placeholder={''}
                  value={title}
                  onChange={event =>
                    this.setState({ title: event.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>Subtitle</td>
              <td className={'input-container-td'}>
                <TextField
                  placeholder={''}
                  value={subtitle}
                  onChange={event =>
                    this.setState({ subtitle: event.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>Notification type</td>
              <td className={'input-container-td'}>
                <TextField
                  placeholder={''}
                  value={type}
                  onChange={event =>
                    this.setState({ type: event.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>Show image in the content</td>
              <td className={'input-container-td'}>
                <Checkbox
                  checked={showImageInContent}
                  onChange={event => {
                    if (showImageInContent !== event.target.checked) {
                      this.setState({
                        showImageInContent: event.target.checked
                      });
                    }
                  }}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              </td>
            </tr>
            <tr>
              <td>Description</td>
              <td className={'input-container-td'}>
                <TextField
                  multiline={true}
                  name=""
                  id=""
                  cols="30"
                  rows="10"
                  value={description}
                  onChange={event =>
                    this.setState({ description: event.target.value })
                  }
                />
              </td>
            </tr>

            <tr>
              <td>Image url</td>
              <td className={'input-container-td'}>
                <TextField
                  placeholder={''}
                  value={imageUrl}
                  onChange={event =>
                    this.setState({ imageUrl: event.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>Youtube video id</td>
              <td className={'input-container-td'}>
                <TextField
                  placeholder={''}
                  value={videoUrl}
                  onChange={event =>
                    this.setState({ videoUrl: event.target.value })
                  }
                />
              </td>
            </tr>

            <tr>
              <td>Action Button Text</td>
              <td className={'input-container-td'}>
                <TextField
                  placeholder={''}
                  value={actionButtonText}
                  onChange={event =>
                    this.setState({ actionButtonText: event.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>Action Button Link</td>
              <td className={'input-container-td'}>
                <TextField
                  placeholder={''}
                  value={actionButtonLink}
                  onChange={event =>
                    this.setState({ actionButtonLink: event.target.value })
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div className={'button-send-notification'}>
          <Button
            className={'button-send-notification'}
            variant={'contained'}
            raised
            color="primary"
            onClick={this.sendNotification}
          >
            Send notification
          </Button>
        </div>
      </div>
    );
  };

  render() {
    const { roles } = this.props;
    const { snackbarMessage } = this.state;
    return (
      <div className="App">
        <div
          style={{
            marginTop: 100
          }}
        />

        {roles && roles.indexOf('notification') !== -1 ? (
          this.renderScreen()
        ) : (
          <div
            style={{
              textAlign: 'center',
              fontSize: '50px',
              color: 'red',
              marginTop: 133
            }}
          >
            You dont have access to this page
          </div>
        )}

        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          open={!!snackbarMessage}
          autoHideDuration={3000}
          onClose={() => {
            this.setState({ snackbarMessage: '' });
          }}
          message={snackbarMessage}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  roles: state.auth.roles
});

export default connect(mapStateToProps)(NotificationDashboard);



// WEBPACK FOOTER //
// ./src/pages/NotificationDashboard/index.js